module.exports = __webpack_public_path__ + "static/media/coming_soon.a31fd3c4.svg";